<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m20 3h-1v-2h-2v2h-10v-2h-2v2h-1c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-16c0-1.1-.9-2-2-2zm0 18h-16v-11h16zm0-13h-16v-3h16z"
    />
  </svg>
</template>
